import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { CITIES, cityToSlug } from "../data/cities";

export const CitiesGrid = () => (
  <section id="zones" className="py-20 md:py-28 bg-[#0F172A] text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">
        Zone d'intervention
      </div>
      <h2
        className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-4"
        style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
      >
        Débouchage canalisation dans tout le 93.
      </h2>
      <p className="text-white/70 text-base md:text-lg max-w-2xl mb-12">
        Cliquez sur votre ville pour découvrir notre service local de{" "}
        <strong className="text-white">débouchage canalisation</strong>, accessible
        24h/24 et 7j/7.
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {CITIES.map((c) => {
          const slug = cityToSlug(c.name);
          return (
            <Link
              key={slug}
              to={`/debouchagecanalisation-${slug}`}
              data-testid={`city-link-${slug}`}
              className="group bg-white/5 hover:bg-[#FF5A1F] border border-white/10 rounded-xl p-4 transition-all hover:-translate-y-1"
            >
              <div className="flex items-center gap-2 text-xs text-[#FF5A1F] group-hover:text-white font-bold uppercase tracking-wider mb-1">
                <MapPin className="w-3.5 h-3.5" />
                {c.cp}
              </div>
              <div className="font-extrabold text-sm md:text-base tracking-tight">
                {c.name}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default CitiesGrid;
